import { IAutomationObject } from '../../types'

export interface IFolder extends IAutomationObject {
}

export const schema = 'AutomationApps.Misc.Folder';